import { inBrowser } from '@activebrands/core-web/utils/constants';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export const getPrefersReducedMotion = (): boolean => {
    if (!inBrowser) {
        return false;
    }

    return window.matchMedia(REDUCED_MOTION_QUERY).matches;
};

export const subscribePrefersReducedMotion = (callback: (prefersReducedMotion: boolean) => void): (() => void) => {
    if (!inBrowser) {
        return () => undefined;
    }

    const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY);
    const handler = () => callback(mediaQuery.matches);

    handler();
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
};
